// removed by extract-text-webpack-plugin
module.exports = {"flexColumn":"flexColumn__zgUKW","flexRow":"flexRow__10njs","buttonStyle":"buttonStyle__2v87A","loadingButtonStyle":"loadingButtonStyle__Wly8_"};


//////////////////
// WEBPACK FOOTER
// ./components/checkoutWidget/style.css
// module id = FUfM
// module chunks = 380